import { Component, OnInit, Inject, ViewEncapsulation, SimpleChanges } from '@angular/core';
import { Pipe, PipeTransform } from '@angular/core';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { EmpInfo } from '../model/emp.model';
import { SaleOrganizationInfo } from '../model/SaleOrganization.model';
import { GlobalService } from '../service/global.service';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormControl,

  FormArray
} from '@angular/forms';

import {
  HttpClient,
  HttpHeaders
} from "@angular/common/http";
import {
  environment
} from 'src/environments/environment';
import { LookupInfo } from '../model/lookup.model';
import { CompanyInfo } from '../model/company.model';
import { ProjectGroupInfo } from '../model/ProjectGroupInfo';
import { TokenService } from '../service/token.service';
import { Router } from '@angular/router';
import { ProjectMemberInfo } from '../model/projectmember.model';
import { StateInfo } from '../model/StateInfo.model';

@Component({
  selector: 'app-assign-managersale',
  encapsulation: ViewEncapsulation.None,
  templateUrl: './assign-managersale.component.html',
  styleUrls: ['./assign-managersale.component.css']
})
export class AssignManagersaleComponent implements OnInit {

  form: FormGroup;

  // ------------------------------- Assign Manager Zone -----------------------------------------------
  AssignBDForm: FormGroup
  AssignBDList: EmpInfo[] = [];
  cuurentselectProjectAssignBD: string = null
  // ------------------------------- Assign Manager Zone -----------------------------------------------

  public body: string;
  ProjectSaleListPromise: Promise<ProjectSaleInfo[]>
  ProjectSaleList: ProjectSaleInfo[] = []
  ProjectSaleListPromisereturn: Promise<ProjectSaleInfo[]>[]
  CompanyList: CompanyInfo[] = []
  CategoryList: LookupInfo[] = []
  StatusList: LookupInfo[] = []
  StateList: StateInfo[] = []
  ProjectSaleTypeList: LookupInfo[] = [];
  ProjectSalePhaseList: LookupInfo[] = [];
  ProjectSaleCustomerTypeList: LookupInfo[] = [];
  empList: EmpInfo[] = [];
  empListLoad: EmpInfo[] = [];
  empListPromise: Promise<EmpInfo[]>
  empListPromiseReturn: Promise<EmpInfo[]>
  saleOrganizationList: SaleOrganizationInfo[] = [];
  saleOrganizationPromise: Promise<SaleOrganizationInfo[]>
  saleOrganizationMaxList: SaleOrganizationInfo[] = [];
  pastYearList: any[] = [];

  // array control
  itemsSupport: FormArray;

  flagduplicate: boolean;
  hidProjectSaleId: number;
  hidProjectSaleState: string;

  // Zone pagination variable
  public indexNo: number = 0
  public currentPageNumber: number
  public totalPages: number
  public environment: number

  public empcodeinit: string
  _EmpCode: string;
  _RoleCode: string;
  hidebutton: Boolean;
  assignflag: boolean;
  viewflag: boolean;
  saleorglevelmax: number;
  saleorglevelemplogin: number;

  public currentPageNumberEmp: number
  public totalPagesEmp: number
  ProjectTotal: any
  EmpTotal: any
  isOnUpdate: boolean = false;
  isViewOnly: boolean = false;
  isSubmitted: any;

  public totalActive: number
  public totalInActive: number
  public totalHold: number
  public totalClosed: number

  element: HTMLElement;
  public hidcouchk: number;
  public countall: number;

  baseurl: string;
  expense_baseurl: string;

  getreturn: Promise<string>;
  monthNameslist: any;
  yearlist: any[];
  today: string;

  isSearchSubmitted: boolean = false;

  titlemodal: string;
  detailmodal: string;

  //empselect
  employeeselectrun: boolean = false;
  selectedemp: EmpInfo;


  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private TokenService: TokenService, private router: Router) {
    this.baseurl = environment.base_api;
    this.expense_baseurl = environment.expense_base_api;
    GlobalService.CheckPagingAccessRights();

  }

  async ngOnInit() {
    this.today = new Date().toLocaleDateString('en-CA');
    this.currentPageNumber = 1;
    // set PageSize
    this.environment = environment.PageSizeSmall;

    this.empcodeinit = localStorage.getItem("EmpCode");
    this._EmpCode = localStorage.getItem("EmpCode");
    this._RoleCode = localStorage.getItem("EmpRoleCode");
    this.currentPageNumberEmp = 1;

    this.monthNameslist = ["January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    this.yearlist = this.generateArrayOfYears();
    this.pastYearList = this.generateArrayOfPastYears(10);
    this.form = this.formBuilder.group({
      ProjectSaleCodeSearch: [null],
      ProjectSaleNameSearch: [null],
      ProjectSaleCompanyIdSearch: [null],
      ProjectSaleStatusSearch: [null],
      ProjectSaleStateSearch: [null],

      ProjectGroupMapping: [null],
      ProjectSaleCode: [null],
      ProjectSaleName: [null, Validators.required],
      ProjectSaleCompanyId: [null, Validators.required],
      ProjectSaleStatus: [null, Validators.required],
      ProjectSaleType: [null, Validators.required],
      ProjectSaleCategory: [null, Validators.required],
      ProjectSaleTool: [null],
      ProjectSalePhase: [null, Validators.required],
      ProjectSaleBudget: [null],
      ProjectSaleExpectedClosePeriodMonth: [null],
      ProjectSaleExpectedClosePerioddYear: [null],
      ProjectSaleContactDate: [null, Validators.required],
      ProjectSaleContactPerson: [null, Validators.required],
      ProjectSaleContactEmail: [null],
      ProjectSaleContactTel: [null, Validators.required],
      ProjectSaleCustomerType: [null, Validators.required],
      arraySupportTeam: this.formBuilder.array([this.createItemSupportTeamName()]),
      ProjectSaleRemark: [null],
      ProjectSaleYear: [null, Validators.required],

      EmpCodeSearch: [null],
      EmpNameSearch: [null],
      // Assign BD Form
      AssignBDForm: this.formBuilder.group({
        ddlAssignBD: [null, Validators.required],
      })
    });

    // set Assign BD Form
    this.AssignBDForm = this.form.get('AssignBDForm') as FormGroup;



    this.Clearinput();

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadCompany(auth_token).then((data) => {
        this.CompanyList = data;
      });

      this.loadLookup('PROJECTSALECATEGORY', auth_token).then((data) => {
        this.CategoryList = data;
      });

      this.loadLookup('PROJECTSALESTATUS', auth_token).then((data) => {
        this.StatusList = data;
      });

      this.loadLookup('PROJECTSALETYPE', auth_token).then((data) => {
        this.ProjectSaleTypeList = data;
      });

      this.loadLookup('PROJECTSALEPHASE', auth_token).then((data) => {
        this.ProjectSalePhaseList = data;
      });

      this.loadLookup('COMPANYCUSTOMERTPYE', auth_token).then((data) => {
        this.ProjectSaleCustomerTypeList = data;
      });
      this.LoadStateList().then((data) => {
        this.StateList = data;
      });
      this.LoadSaleOrganizationLevel(auth_token);
      this.LoadListProjectGroup(auth_token);
      this.LoadCountProjectGroup(auth_token);
    }
  }

  btnClick_SearchProjectSaleList() {
    this.currentPageNumber = 1; // away current page 1 when search
    this.indexNo = 0;

    this.isSearchSubmitted = true;
    this.LoadProjectSale()
  }
  Clearinput() {
    var d = new Date();
    var monthindex = d.getMonth() + 1;
    var year = d.getFullYear();
    this.isSearchSubmitted = false;
    this.form.patchValue({
      ProjectGroupMapping: null,
      ProjectSaleCode: null,
      ProjectSaleName: null,
      ProjectSaleCompanyId: null,
      ProjectSaleStatus: null,
      ProjectSaleType: null,
      ProjectSaleCategory: null,
      ProjectSaleTool: null,
      ProjectSalePhase: null,
      ProjectSaleBudget: null,
      ProjectSaleExpectedClosePeriodMonth: null,
      ProjectSaleExpectedClosePerioddYear: null,
      ProjectSaleContactDate: null,
      ProjectSaleContactPerson: null,
      ProjectSaleContactEmail: null,
      ProjectSaleContactTel: null,
      ProjectSaleCustomerType: null,
      ProjectSaleRemark: null,
      ProjectSaleYear: null,
    });

    // clear support team
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.clear();
    this.itemsSupport.push(this.createItemSupportTeamName());

  }

  createItemSupportTeamName(value = ''): FormGroup {
    return this.formBuilder.group({
      SupporTeamName: [value],
    },
      {
        // Used custom form validator 
        validator: []
      }
    );

  }

  addSupport(): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.push(this.createItemSupportTeamName());
  }

  removeSupportItem(indexitem): void {
    this.itemsSupport = this.form.get('arraySupportTeam') as FormArray;
    this.itemsSupport.removeAt(indexitem);
  }

  ClearSearch() {
    this.form.patchValue({
      ProjectSaleCodeSearch: "",
      ProjectSaleNameSearch: "",
      ProjectSaleCompanyIdSearch: "",
      ProjectSaleStatusSearch: "",
      ProjectSaleStateSearch: "",
    });
    this.currentPageNumber = 1;
    this.indexNo = 0;
    this.LoadProjectSale();
  }

  async LoadProjectSale(traget = null) {

    // check call function from change page or onloadfrist
    if (traget != null) {
      this.LoadProjectSaleUpdatePagination(traget);
    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadProjectSaleList(auth_token);
      this.LoadProjectSaleCountList(auth_token);
    }
  }

  LoadProjectSaleList(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumber - 1) * this.environment;

    var objectjson = {};
    objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
    objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
    objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value)) : 0;
    objectjson['ProjectSaleStatus'] = 56 // active only
    objectjson['ProjectSaleState'] = '1-3' // approve lead only

    objectjson['rowFetch'] = this.environment;
    objectjson['rowOFFSet'] = offset;
    //objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    objectjson['ProjectSaleActiveFlag'] = "Y";
    objectjson['ProjectSaleFlagDelete'] = "N";
    //objectjson['ProjectSaleFlagOrderbyAssign'] = "Y";

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
      .subscribe({
        next: (data) => {
          this.ProjectSaleList = data;

        }
      });


  }

  LoadProjectSaleCountList(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };


    var objectjson = {};
    objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
    objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
    objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value)) : 0;
    objectjson['ProjectSaleStatus'] = 56 // active only
    objectjson['ProjectSaleState'] = '1-3' // approve lead only

    //objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    objectjson['ProjectSaleActiveFlag'] = "Y";
    objectjson['ProjectSaleFlagDelete'] = "N";


    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<number>(this.baseurl + "ProjectSale/GetCountProjectSale", strjson, httpOptions)
      .toPromise().then((data) => {


        this.hidcouchk = data;
        if (this.hidcouchk == 0) {
          this.currentPageNumber = 0;
          this.totalPages = 0;
        } else {
          this.totalPages = Math.ceil(this.hidcouchk / this.environment);
        }
      })


  }


  async LoadProjectSaleAll(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['ProjectSaleCode'] = this.checkUndefinedString(this.form.controls['ProjectSaleCodeSearch'].value);
    objectjson['ProjectSaleName'] = this.checkUndefinedString(this.form.controls['ProjectSaleNameSearch'].value);
    objectjson['ProjectSaleCompanyId'] = this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value) != "" ? parseInt(this.checkUndefinedString(this.form.controls['ProjectSaleCompanyIdSearch'].value)) : 0;
    objectjson['ProjectSaleStatus'] = 56 // active only
    objectjson['ProjectSaleState'] = '1-3' // approve lead only

    //objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    objectjson['ProjectSaleActiveFlag'] = "Y";
    objectjson['ProjectSaleFlagDelete'] = "N";

    //if (this.viewflag == true) {

    //}
    //else {
    //  objectjson['ProjectSaleCurrentEmpCode'] = this.checkUndefinedString(this.empcodeinit);
    //}

    let strjson = JSON.stringify(objectjson);


    this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetProjectSale", strjson, httpOptions)
      .toPromise().then((data) => {
        this.countall = data.length;

        this.totalActive = data.filter(function (el) {
          return el.ProjectSaleStatusDisplay == 'Active'
        }).length;

        this.totalInActive = data.filter(function (el) {
          return el.ProjectSaleStatusDisplay == 'Inactive'
        }).length;

        this.totalHold = data.filter(function (el) {
          return el.ProjectSaleStatusDisplay == 'Hold'
        }).length;

        this.totalClosed = data.filter(function (el) {
          return el.ProjectSaleStatusDisplay == 'Closed'
        }).length;

      })


  }

  isFieldValid(field: string) {
    $('#isFieldValid')
    return this.form.get(field).invalid && this.form.get(field).touched;
  }

  displayFieldCss(field: string) {
    return {
      'has-error': this.isFieldValid(field),
      'has-feedback': this.isFieldValid(field)
    };
  }


  async loadCompany(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<CompanyInfo[]>(this.baseurl + "Company/GetCompany", strjson, httpOptions)
      .toPromise()
  }

  async loadLookup(lookuptype: string, auth_token: string) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    objectjson['LookupType'] = this.checkUndefinedString(lookuptype);

    let strjson = JSON.stringify(objectjson);

    return await this.httpClient.post<LookupInfo[]>(this.baseurl + "Lookup/GetLookup", strjson, httpOptions)
      .toPromise()
  }
  async LoadStateList(dataId: number = 0): Promise<StateInfo[]> {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let offset = (this.currentPageNumber - 1) * environment.PageSizeMedium;
      var objectjson = {};
      objectjson['Id'] = dataId;
      objectjson['CycleCode'] = "1";

      objectjson['rowFetch'] = environment.PageSizeMedium;
      objectjson['rowOFFSet'] = offset;

      let strjson = JSON.stringify(objectjson);

      console.log(strjson);

      return this.httpClient.post<StateInfo[]>(this.baseurl + "MasterSale/GetStateManagementList", strjson, httpOptions)
        .toPromise()
    }
  }

  checkUndefinedString(strInput: string) {
    if (strInput === undefined || strInput === null) {
      strInput = ''
    }
    return strInput

  }


  formatDate(date) {
    var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2)
      month = '0' + month;
    if (day.length < 2)
      day = '0' + day;

    return [year, month, day].join('-');
  }

  ConvertDate(DateValue) {
    if (DateValue) {

      var date = new Date(DateValue);
      var dayname = date.getDay();
      var day = date.getDate();
      var daystr = '';

      if (day < 10) {
        daystr = '0' + day
      } else {
        daystr = day.toString();
      }


      var monthIndex = date.getMonth() + 1;
      var monthstr = '';

      if (monthIndex < 10) {
        monthstr = '0' + monthIndex
      } else {
        monthstr = monthIndex.toString();
      }

      var year = date.getFullYear();
      var Hours = date.getHours();
      var Minutes = date.getMinutes();

      var Datenow = '';

      Datenow = monthstr + "/" + daystr + "/" + year;
    }
    else {

      Datenow = null;
    }

    return Datenow;

  }



  displayhyperlink(projectcode: string, projectsaleid: number) {
    var body = ""
    body += " <a href=\"/saletracking-management?ProjectSaleID=" + projectsaleid + "\">" + projectcode + "</a>"

    return body;
  }

  generateArrayOfYears() {
    var max = new Date().getFullYear() + 5
    var min = max - 5
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }

  generateArrayOfPastYears(number) {
    var max = new Date().getFullYear()
    var min = max - number
    var years = []

    for (var i = max; i >= min; i--) {
      years.push(i)
    }
    return years
  }


  async btnonclick_loadcompany() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadCompany(auth_token).then((data) => {
        this.CompanyList = data;
      });
    }
  }

  async btnonclick_loadCategory() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.loadLookup('PROJECTSALECATEGORY', auth_token).then((data) => {
        this.CategoryList = data;
      });
    }
  }


  ClearSearchEmp() {
    this.form.patchValue({
      EmpCodeSearch: "",
      EmpNameSearch: "",
    });
  }

  async LoadEmp() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadEmpList(auth_token)
        .then(
          data => {
            this.empList = data;
          }
        ).then(() => {
          this.CountEmpList(auth_token);
        })
    }
  }

  LoadEmpList(auth_token): Promise<EmpInfo[]> {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
    objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);
    objectjson['FlagDelete'] = 'N';
    objectjson['rowFetch'] = environment.PageSizeSmall;
    objectjson['rowOFFSet'] = offset;

    let strjson = JSON.stringify(objectjson);

    this.empListPromise = this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
      .toPromise()

    return this.empListPromise;
  }

  CountEmpList(auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['EmpCode'] = this.checkUndefinedString(this.form.controls['EmpCodeSearch'].value);
    objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);
    objectjson['FlagDelete'] = 'N';

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetCountEmployeeCriteria", strjson, httpOptions)
      .toPromise().then(data => {
      })
      .then(() => {
      })

  }

  async btnClickshowEmp() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadEmpforAssign(auth_token);
    }
  }


  LoadSaleOrganizationLevel(auth_token) {

    this.LoadSaleOrganizationLevelList(auth_token).then(async data => {
      this.saleOrganizationList = data;
      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].AssignFlag == 'Y') {
          this.hidebutton = false;
          this.assignflag = false;
        }
        else {
          this.hidebutton = true;
          this.assignflag = true;
        }
      }
      else {
        this.hidebutton = true;
        this.assignflag = true;
      }

      if (this.saleOrganizationList.length > 0) {
        if (this.saleOrganizationList[0].ViewFlag == 'Y') {
          this.viewflag = true;
        }
        else {
          this.viewflag = false;
        }
      }
      else {
        this.viewflag = false;
      }

      if (this.saleOrganizationList.length > 0) {
        this.saleorglevelemplogin = this.saleOrganizationList[0].Levels
      }
      else {
        this.saleorglevelemplogin = 1;
      }

      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        this.LoadProjectSale();
        this.LoadProjectSaleAll(auth_token);
      }
    })
      .then(async () => {
        var auth_token = await this.TokenService.RefreshToken();
        if (!!auth_token) {
          this.LoadSaleOrganizationLevelmax(auth_token);
        }

      });
  }

  LoadSaleOrganizationLevelList(auth_token): Promise<SaleOrganizationInfo[]> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['EmpCode'] = this.checkUndefinedString(this.empcodeinit);

    let strjson = JSON.stringify(objectjson);

    this.saleOrganizationPromise = this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
      .toPromise()

    return this.saleOrganizationPromise;
  }

  LoadSaleOrganizationLevelmax(auth_token) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<SaleOrganizationInfo[]>(this.baseurl + "SaleOrganization/GetSaleOrganization", strjson, httpOptions)
      .toPromise().then(
        async data => {
          this.saleOrganizationMaxList = data;
          this.saleOrganizationMaxList = this.saleOrganizationMaxList.sort((a, b) => a.Levels - b.Levels);

          if (this.saleOrganizationMaxList.length > 0) {
            this.saleorglevelmax = this.saleOrganizationMaxList[this.saleOrganizationMaxList.length - 1].Levels;

          }
          else {
            this.saleorglevelmax = 1;
          }

          //var auth_token = await this.TokenService.RefreshToken();
          //if (!!auth_token) {
          //  this.LoadEmpforAssign(auth_token);
          //}
        })
  }

  LoadEmpforAssign(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['saleorglevel'] = this.saleorglevelemplogin;
    objectjson['saleorglevelmax'] = this.saleorglevelmax;
    objectjson['rowFetch'] = environment.PageSizeSmall;
    objectjson['rowOFFSet'] = offset;
    objectjson['EmpCode'] = this._EmpCode;
    objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmpforAssignProjectSale", strjson, httpOptions)
      .toPromise().then(
        async data => {
          this.empListLoad = data;

          if (data.length == 0) {
            $('#ModalEmpAssign').modal('hide');

            this.titlemodal = '';
            this.detailmodal = 'To assign projects, please add sellers to your team at least 1 person.';
            $('#ModalError .modal-header').text("Sorry");
            $('#ModalError').modal();
          }


          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            this.CountLoadEmpforAssign(auth_token);
          }
        }).then(() => {

        }).catch(function (err) {

        });
  }

  CountLoadEmpforAssign(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    let offset = (this.currentPageNumberEmp - 1) * environment.PageSizeSmall;

    var objectjson = {};
    objectjson['saleorglevel'] = this.saleorglevelemplogin;
    objectjson['saleorglevelmax'] = this.saleorglevelmax;
    objectjson['EmpCode'] = this._EmpCode;
    objectjson['EmpName_TH'] = this.checkUndefinedString(this.form.controls['EmpNameSearch'].value);

    let strjson = JSON.stringify(objectjson);

    this.httpClient.post<number>(this.baseurl + "Employee/GetCountEmpforAssignProjectSale", strjson, httpOptions)
      .toPromise().then(data => {
        this.EmpTotal = data;
        if (this.EmpTotal == 0) this.currentPageNumberEmp = 0;
      })
      .then(() => {
        this.totalPagesEmp = Math.ceil(this.EmpTotal / environment.PageSizeSmall);
      })


  }

  async assignclicked(item) {

    if (confirm("Are you sure you want to assign sale employee?")) {
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {
        $('#ModalEmpAssign').modal('hide');
        let EmpCode = this.empListLoad.findIndex(x => x.Id == item);

        var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');

        let num = checkkedProjectSale.length;
        let observableBatch = [];

        for (var i = 0; i < num; i++) {

          var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];
          observableBatch.push(this.btnClick_assignProjectSale(parseInt(ProjectSalecurrent.value), item, this._EmpCode, auth_token).toPromise().then(val => {
          }));
        }

        Promise.all(observableBatch).then(async val => {
          console.log('สำเร็จ');
          $('#ModalEmpAssignComplate').modal('show');
          var auth_token = await this.TokenService.RefreshToken();
          if (!!auth_token) {
            this.LoadProjectSale();
            this.LoadEmpforAssign(auth_token);
          }
        });
      }
    }
  }

  btnClick_assignProjectSale(id, AssignTo, AssignBy, auth_token): Observable<ProjectSaleInfo[]> {


    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };
    var objectjson = {};
    objectjson['ProjectSaleId'] = id;
    objectjson['ProjectSaleAssignTo'] = AssignTo;
    objectjson['ProjectSaleAssignBy'] = AssignBy;
    objectjson['ProjectSaleUpdateBy'] = AssignBy;

    let strjsonCusInfo = JSON.stringify(objectjson);

    return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/AssignEmpProjectSale", strjsonCusInfo, httpOptions);

  }


  ConvertFormArrayToJson(objectFormArray: FormArray): string {
    var objectarray = [];
    $.each(objectFormArray.controls, function (index, value) {
      objectarray.push(value.value);
    });

    return JSON.stringify(objectarray);

  }

  // Function Update variable abount pagination
  LoadProjectSaleUpdatePagination(traget) {

    this.currentPageNumber = traget.currentPageNumber;
    this.totalPages = traget.totalPages;
    this.indexNo = traget.index;
  }

  //Lead group
  //function Update Group projectsale
  //1. Get list project group to modal
  //2. Send list projs id to save 
  //Variables
  listProjGroup: ProjectGroupInfo[] = [];
  totalProjectGroup: number;
  totalPage_ProjectGroup: number;
  currentPageNumber_ProjectGroup: number;

  LoadListProjectGroup(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    let strjson = JSON.stringify(objectjson);

    this.httpClient
      .post<ProjectGroupInfo[]>(this.baseurl + "Master/GetProjectGroup",
        strjson, httpOptions)
      .subscribe(data => {
        this.listProjGroup = data;
      });
  }
  LoadCountProjectGroup(auth_token) {

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth_token}`
      })
    };

    var objectjson = {};
    let strjson = JSON.stringify(objectjson);

    this.httpClient
      .post<number>(this.baseurl + "Master/GetCountProjectGroup",
        strjson, httpOptions)
      .subscribe(data => {

        this.currentPageNumber_ProjectGroup = 1;
        this.totalProjectGroup = data;//จำนวน data ทั้งหมด
        this.totalPage_ProjectGroup = Math.ceil(this.totalProjectGroup / environment.PageSizeSmall);//จำนวนที่แบ่ง page ได้
      });
  }

  async OnLoadProjGroupFinished(traget = null) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumber_ProjectGroup = traget.currentPageNumber;
      this.totalPage_ProjectGroup = traget.totalPages;
    }
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      this.LoadListProjectGroup(auth_token);
    }
  }
  OnBtnOpenProjectGroupModalClick() {
    $('#ModalProjectGroup').modal();
  }
  OnBtnAssignGroupProjectSaleList(groupcode) {

    if (confirm("Are you sure you want to Update group this Project?")) {

      var checkkedProjectSale = $('[name="checkboxProjectSale"]:checked');
      var Groupproject = groupcode;
      let num = checkkedProjectSale.length;
      let observableBatch = [];
      for (var i = 0; i < num; i++) {

        var ProjectSalecurrent = <HTMLInputElement>checkkedProjectSale[i];

        var projcode = $(ProjectSalecurrent).data('projcode');
        observableBatch.push(this.btnClick_UpdateGroupProjectSale(parseInt(ProjectSalecurrent.value), projcode, Groupproject).toPromise().then(val => {
        }));
      }

      Promise.all(observableBatch).then(val => {


        this.SendListIdToUpdateGroup(observableBatch);

      });

    }

  }

  btnClick_UpdateGroupProjectSale(id, projcode, Groupproject): Observable<ProjectSaleInfo[]> {
    var auth_token = this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };
      var objectjson = {};
      objectjson['ProjectSaleId'] = id;
      objectjson['ProjectSaleCode'] = projcode;
      objectjson['ProjectGroupMapping'] = Groupproject;

      let strjsonCusInfo = JSON.stringify(objectjson);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSaleByGroup", strjsonCusInfo, httpOptions);
    }
  }

  async SendListIdToUpdateGroup(observableBatch: any[]) {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      let strjsonCusInfo = JSON.stringify(observableBatch);

      return this.httpClient.post<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/UpdateGroupProjectSaleByGroup", strjsonCusInfo, httpOptions)
        .toPromise()
        .then(
          data => {
            console.log('สำเร็จ');
            $('#ModalProjectGroupComplate').modal('show');
            this.currentPageNumber = 1;
            this.LoadProjectSale();

          }
        );
    }
  }

  //For Pagination
  async OnPaginationLoaded(traget) {
    if (traget != null) { // check call function from change page or onloadfrist
      this.currentPageNumberEmp = traget.currentPageNumber;
      this.totalPagesEmp = traget.totalPages;
    }

    //var auth_token = await this.TokenService.RefreshToken();
    //if (!!auth_token) {

    //  this.LoadEmpforAssign(auth_token);
    //}
  }
  // ------------------------------- Assign BD Zone -----------------------------------------------

  async loadDDLAssignBD() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      var objectjson = {};
      objectjson['RoleCode'] = 'BDandSeller';  // Business Development or Seller

      let strjson = JSON.stringify(objectjson);

      await this.httpClient.post<EmpInfo[]>(this.baseurl + "Employee/GetEmployeeCriteria", strjson, httpOptions)
        .toPromise().then((data) => {
          this.AssignBDList = data;
        });
    }
  }


  async btnAssignBDClick(ProjectCode, EmpAssignBD: string) {
    // reset form
    this.AssignBDForm.reset();
    //set current select project
    this.cuurentselectProjectAssignBD = ProjectCode;
    // load ddl AssignPM
    await this.loadDDLAssignBD();

    // set current Assign PM
    this.AssignBDForm.patchValue({
      ddlAssignBD: EmpAssignBD,
    });

    // show modal Assign BD
    this.employeeselectrun = true;
    $('#ModalAssignBD').modal();
  }

  async btnSubmitAssignBDClick() {
    //if (this.AssignBDForm.valid) {
    if (this.selectedemp != null) { 
      // hide modal Assign BD
      $('#ModalAssignBD').modal('hide');
      this.employeeselectrun = false;

      // save AssignPM
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        //var EmpAssignBD = this.AssignBDForm.get('ddlAssignBD').value;
        //var EmpRoleAssignBD = $('#selectAssignBD option:selected').attr('emprolecode');

        var EmpAssignBD = this.selectedemp.EmpCode;
        var EmpRoleAssignBD = this.selectedemp.RoleCode;

        var objectjson = {};
        objectjson['EmpCode'] = this.checkUndefinedString(EmpAssignBD);
        objectjson['EmpRole'] = this.checkUndefinedString(EmpRoleAssignBD);
        objectjson['ProjectCode'] = this.checkUndefinedString(this.cuurentselectProjectAssignBD);
        objectjson['ProjectType'] = 'Lead';
        objectjson['PositionInProject'] = '5'; // from lookup MASTERPROJECTROLE 5 = Business Development

        objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);


        this.isSubmitted = await this.httpClient.post<ProjectMemberInfo[]>(this.baseurl + "ProjectMember/SaveAssignManagerProject", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")
            this.titlemodal = 'Update Assign fail.';
            this.detailmodal = 'Action Assign BD was update fail.';

            $('#ModalError').modal();

          },
            async () => {
              console.log("Update = " + this.isSubmitted)

              //  // ยังไม่ใช้งาน
              //this.expenseclaims_SubmitAssignBDClick()

              await this.LoadProjectSale();
              await this.LoadProjectSaleAll(auth_token);

              this.titlemodal = 'Submit Assign BD succeed.';
              this.detailmodal = 'Update Assign BD completed.';

              $('#ModalComplate').modal();

            }
          )

      }

    } else {
      //mark FormGroup Touched
      this.GlobalService.validateAllFormFields(this.AssignBDForm)
      alert("Please select an employee")
    }

  }

  async expenseclaims_SubmitAssignBDClick() {
    if (true) {
      // save AssignPM
      var auth_token = await this.TokenService.RefreshToken();
      if (!!auth_token) {

        const httpOptions = {
          headers: new HttpHeaders({
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${auth_token}`
          })
        };
        var EmpAssignBD = this.AssignBDForm.get('ddlAssignBD').value;
        var EmpRoleAssignBD = $('#selectAssignBD option:selected').attr('emprolecode');

        var objectjson = {};
        objectjson['EmpCode'] = this.checkUndefinedString(EmpAssignBD.toString());
        objectjson['EmpRole'] = this.checkUndefinedString(EmpRoleAssignBD.toString());
        objectjson['ProjectCode'] = this.checkUndefinedString(this.cuurentselectProjectAssignBD);
        objectjson['ProjectType'] = 'Lead';
        objectjson['PositionInProject'] = '5'; // from lookup MASTERPROJECTROLE 5 = Business Development

        objectjson['UpdateBy'] = this.checkUndefinedString(localStorage.getItem("EmpCode"));

        let strjson = JSON.stringify(objectjson);


        this.isSubmitted = await this.httpClient.post<ProjectMemberInfo[]>(this.expense_baseurl + "ProjectMember/SaveAssignManagerProject", strjson, httpOptions)

          .subscribe(result => this.isSubmitted = result, failCb => {
            console.log("Update fail")

          },
            async () => {
              console.log("Update = " + this.isSubmitted)
            }
          )

      }

    }

  }
  // ------------------------------- Assign BD Zone -----------------------------------------------

  selectedEmp(event) {
    console.log("SELECTED EMP")

    this.selectedemp = event[0];
    console.log(this.selectedemp)


  }
}
